import React from 'react';

/* eslint-disable max-len */

interface Svg extends React.SVGProps<SVGSVGElement> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export function Svg({
  children,
  className = '',
  viewBox = '0 0 24 24',
  style = {},
  ...props
}: Svg): React.ReactNode {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      height="1em"
      width="1em"
      viewBox={viewBox}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}
    >
      {children}
    </svg>
  );
}

export function IconDockToLeft(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <mask id="mask0_599_9869" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_599_9869)">
        <path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM16 19H19V5H16V19ZM14 19V5H5V19H14Z" />
      </g>
    </Svg>
  );
}

export function IconDockToRight(props: Partial<Svg>) {
  return (
    <IconDockToLeft {...props} style={{ transform: 'scale(-1, 1)', ...(props?.style || {}) }} />
  );
}

export function IconNotificationOff(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> */}
      <mask id="mask0_1004_8935" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1004_8935)">
        <path
          d="M4.00002 19V17H6.00002V10C6.00002 9.45 6.07086 8.90833 6.21252 8.375C6.35419 7.84167 6.56669 7.33333 6.85002 6.85L8.35003 8.35C8.23336 8.61667 8.14586 8.8875 8.08752 9.1625C8.02919 9.4375 8.00002 9.71667 8.00002 10V17H14.2L1.40002 4.2L2.80002 2.8L21.2 21.2L19.8 22.6L16.15 19H4.00002ZM18 15.15L16 13.15V10C16 8.9 15.6084 7.95833 14.825 7.175C14.0417 6.39167 13.1 6 12 6C11.5667 6 11.15 6.06667 10.75 6.2C10.35 6.33333 9.98336 6.53333 9.65003 6.8L8.20003 5.35C8.53336 5.08333 8.89169 4.85 9.27502 4.65C9.65836 4.45 10.0667 4.3 10.5 4.2V3.5C10.5 3.08333 10.6459 2.72917 10.9375 2.4375C11.2292 2.14583 11.5834 2 12 2C12.4167 2 12.7709 2.14583 13.0625 2.4375C13.3542 2.72917 13.5 3.08333 13.5 3.5V4.2C14.8334 4.53333 15.9167 5.2375 16.75 6.3125C17.5834 7.3875 18 8.61667 18 10V15.15ZM12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1959 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0209 21.8042 12.55 22 12 22Z"
          fill="currentColor" // #555555
        />
      </g>
      {/* </svg> */}

    </Svg>
  );
}
export function IconFrontHand(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
      <mask
        id="mask0_1004_8940"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_1004_8940)">
        <path
          d="M12 12V2C12 1.71667 12.0958 1.47917 12.2875 1.2875C12.4792 1.09583 12.7167 1 13 1C13.2833 1 13.5208 1.09583 13.7125 1.2875C13.9042 1.47917 14 1.71667 14 2V12H12ZM8 12V3C8 2.71667 8.09583 2.47917 8.2875 2.2875C8.47917 2.09583 8.71667 2 9 2C9.28333 2 9.52083 2.09583 9.7125 2.2875C9.90417 2.47917 10 2.71667 10 3V12H8ZM12.5 23C10.1333 23 8.125 22.175 6.475 20.525C4.825 18.875 4 16.8667 4 14.5V5C4 4.71667 4.09583 4.47917 4.2875 4.2875C4.47917 4.09583 4.71667 4 5 4C5.28333 4 5.52083 4.09583 5.7125 4.2875C5.90417 4.47917 6 4.71667 6 5V14.5C6 16.3167 6.62917 17.8542 7.8875 19.1125C9.14583 20.3708 10.6833 21 12.5 21C14.3167 21 15.8542 20.3708 17.1125 19.1125C18.3708 17.8542 19 16.3167 19 14.5V11C18.7167 11 18.4792 11.0958 18.2875 11.2875C18.0958 11.4792 18 11.7167 18 12V16H15C14.45 16 13.9792 16.1958 13.5875 16.5875C13.1958 16.9792 13 17.45 13 18V19H11V18C11 16.9 11.3917 15.9583 12.175 15.175C12.9583 14.3917 13.9 14 15 14H16V4C16 3.71667 16.0958 3.47917 16.2875 3.2875C16.4792 3.09583 16.7167 3 17 3C17.2833 3 17.5208 3.09583 17.7125 3.2875C17.9042 3.47917 18 3.71667 18 4V9.175C18.1667 9.125 18.3292 9.08333 18.4875 9.05C18.6458 9.01667 18.8167 9 19 9H21V14.5C21 16.8667 20.175 18.875 18.525 20.525C16.875 22.175 14.8667 23 12.5 23Z"
          fill="currentColor"
        />
      </g>
    </Svg>
  );
}
export function IconReply(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
      <mask
        id="mask0_1055_4226"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1055_4226)">
        <path
          d="M12.6667 12.6663V9.99967C12.6667 9.44412 12.4722 8.9719 12.0833 8.58301C11.6944 8.19412 11.2222 7.99967 10.6667 7.99967H4.55L6.95 10.3997L6 11.333L2 7.33301L6 3.33301L6.95 4.26634L4.55 6.66634H10.6667C11.5889 6.66634 12.375 6.99134 13.025 7.64134C13.675 8.29134 14 9.07745 14 9.99967V12.6663H12.6667Z"
          fill="#555555"
        />
      </g>

    </Svg>
  );
}
export function IconContentCopy(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
      <mask
        id="mask0_1055_4231"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1055_4231)">
        <path
          d="M6 11.9997C5.63333 11.9997 5.31944 11.8691 5.05833 11.608C4.79722 11.3469 4.66667 11.033 4.66667 10.6663V2.66634C4.66667 2.29967 4.79722 1.98579 5.05833 1.72467C5.31944 1.46356 5.63333 1.33301 6 1.33301H12C12.3667 1.33301 12.6806 1.46356 12.9417 1.72467C13.2028 1.98579 13.3333 2.29967 13.3333 2.66634V10.6663C13.3333 11.033 13.2028 11.3469 12.9417 11.608C12.6806 11.8691 12.3667 11.9997 12 11.9997H6ZM6 10.6663H12V2.66634H6V10.6663ZM3.33333 14.6663C2.96667 14.6663 2.65278 14.5358 2.39167 14.2747C2.13056 14.0136 2 13.6997 2 13.333V3.99967H3.33333V13.333H10.6667V14.6663H3.33333Z"
          fill="#555555"
        />
      </g>
    </Svg>
  );
}
export function IconPencilEdit(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
      <mask
        id="mask0_1055_4236"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1055_4236)">
        <path
          d="M1.33337 15.9997V13.333H14.6667V15.9997H1.33337ZM4.00004 10.6663H4.93337L10.1334 5.48301L9.18337 4.53301L4.00004 9.73301V10.6663ZM2.66671 11.9997V9.16634L10.1334 1.71634C10.2556 1.59412 10.3973 1.49967 10.5584 1.43301C10.7195 1.36634 10.8889 1.33301 11.0667 1.33301C11.2445 1.33301 11.4167 1.36634 11.5834 1.43301C11.75 1.49967 11.9 1.59967 12.0334 1.73301L12.95 2.66634C13.0834 2.78856 13.1806 2.93301 13.2417 3.09967C13.3028 3.26634 13.3334 3.43856 13.3334 3.61634C13.3334 3.78301 13.3028 3.9469 13.2417 4.10801C13.1806 4.26912 13.0834 4.41634 12.95 4.54967L5.50004 11.9997H2.66671Z"
          fill="#555555"
        />
      </g>
    </Svg>
  );
}
export function IconForward(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
      <mask
        id="mask0_1055_4241"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1055_4241)">
        <path
          d="M3.99996 15.3337C3.63329 15.3337 3.3194 15.2031 3.05829 14.942C2.79718 14.6809 2.66663 14.367 2.66663 14.0003V6.66699C2.66663 6.30033 2.79718 5.98644 3.05829 5.72533C3.3194 5.46421 3.63329 5.33366 3.99996 5.33366H5.99996V6.66699H3.99996V14.0003H12V6.66699H9.99996V5.33366H12C12.3666 5.33366 12.6805 5.46421 12.9416 5.72533C13.2027 5.98644 13.3333 6.30033 13.3333 6.66699V14.0003C13.3333 14.367 13.2027 14.6809 12.9416 14.942C12.6805 15.2031 12.3666 15.3337 12 15.3337H3.99996ZM7.33329 10.667V3.21699L6.26663 4.28366L5.33329 3.33366L7.99996 0.666992L10.6666 3.33366L9.73329 4.28366L8.66663 3.21699V10.667H7.33329Z"
          fill="#555555"
        />
      </g>

    </Svg>
  );
}
export function IconDelete(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
      <mask
        id="mask0_1055_4247"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1055_4247)">
        <path
          d="M4.66663 14C4.29996 14 3.98607 13.8694 3.72496 13.6083C3.46385 13.3472 3.33329 13.0333 3.33329 12.6667V4H2.66663V2.66667H5.99996V2H9.99996V2.66667H13.3333V4H12.6666V12.6667C12.6666 13.0333 12.5361 13.3472 12.275 13.6083C12.0138 13.8694 11.7 14 11.3333 14H4.66663ZM11.3333 4H4.66663V12.6667H11.3333V4ZM5.99996 11.3333H7.33329V5.33333H5.99996V11.3333ZM8.66663 11.3333H9.99996V5.33333H8.66663V11.3333Z"
          fill="#555555"
        />
      </g>

    </Svg>
  );
}
export function IconPlus(props: Partial<Svg>) {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <mask
        id="mask0_1070_4517"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1070_4517)">
        <path d="M11 13H5V11H11V5H13V11H19V13H13V19H11V13Z" fill="#555555" />
      </g>
    </Svg>
  );
}
export function IconPhone(props: Partial<Svg>) {
  return (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 4C8 3.73478 7.89457 3.48051 7.70703 3.29297C7.54289 3.12883 7.32763 3.02757 7.09863 3.00488L7 3H4C3.73478 3 3.4805 3.10543 3.29297 3.29297C3.10543 3.4805 3 3.73478 3 4L3.00488 4.42188C3.11289 8.77767 4.89094 12.932 7.97949 16.0205C11.1676 19.2086 15.4913 21 20 21C20.2652 21 20.5195 20.8946 20.707 20.707C20.8946 20.5195 21 20.2652 21 20V17C21 16.7348 20.8946 16.4805 20.707 16.293C20.5195 16.1054 20.2652 16 20 16H17C16.8448 16 16.6916 16.036 16.5527 16.1055C16.4139 16.1749 16.2933 16.2762 16.2002 16.4004L16.1953 16.4072L15.8398 16.8701L15.8408 16.8711C15.5656 17.2326 15.1752 17.4894 14.7344 17.5996C14.3486 17.696 13.944 17.6748 13.5723 17.541L13.415 17.4766L13.3916 17.4658C10.4157 16.0053 8.00728 13.6 6.54297 10.626L6.54102 10.6221C6.33868 10.2069 6.28622 9.73455 6.39258 9.28516C6.49903 8.83567 6.75789 8.4366 7.125 8.15625L7.13184 8.15137L7.59961 7.7998L7.68848 7.72559C7.77262 7.64574 7.84239 7.55154 7.89453 7.44727C7.96396 7.30841 8 7.15525 8 7V4ZM10 7C10 7.46573 9.89188 7.92523 9.68359 8.3418C9.5014 8.70619 9.24674 9.0288 8.93652 9.29102L8.7998 9.40039L8.33789 9.74512C9.60317 12.3136 11.6816 14.3917 14.249 15.6582L14.5996 15.2002L14.709 15.0635C14.9712 14.7533 15.2938 14.4986 15.6582 14.3164C16.0748 14.1081 16.5343 14 17 14H20C20.7957 14 21.5585 14.3163 22.1211 14.8789C22.6837 15.4415 23 16.2043 23 17V20C23 20.7957 22.6837 21.5585 22.1211 22.1211C21.5585 22.6837 20.7957 23 20 23C14.9609 23 10.1286 20.9978 6.56543 17.4346C3.11356 13.9827 1.12662 9.33986 1.00586 4.47168L1 4C1 3.20435 1.3163 2.44152 1.87891 1.87891C2.44152 1.3163 3.20435 1 4 1H7L7.29688 1.01465C7.98351 1.08291 8.6289 1.38671 9.12109 1.87891C9.6837 2.44151 10 3.20435 10 4V7Z" fill="#284F66" />
    </Svg>
  );
}

export function IconMail(props: Partial<Svg>) {
  return (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M20 3C21.6569 3 23 4.34315 23 6V18C23 19.6569 21.6569 21 20 21H4C2.34315 21 1 19.6569 1 18V6C1 4.34315 2.34315 3 4 3H20ZM3 18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V8.82227L13.5459 13.5703C13.5346 13.5775 13.5233 13.5851 13.5117 13.5918C13.1112 13.8244 12.6625 13.9608 12.2021 13.9912L12.0049 13.9971C11.4758 13.9971 10.9556 13.8575 10.498 13.5918C10.4864 13.585 10.4743 13.5775 10.4629 13.5703L3 8.82129V18ZM4 5C3.44772 5 3 5.44772 3 6V6.4502L11.5078 11.8652C11.659 11.9518 11.8306 11.9971 12.0049 11.9971L12.1357 11.9893C12.2637 11.9723 12.3872 11.9296 12.5 11.8652L21 6.4502V6C21 5.44772 20.5523 5 20 5H4Z" fill="#284F66" />
    </Svg>
  );
}

export function IconInfoPublisher({
  width = 37,
  height = 36,
  opacity = 1,
  ...props
}: Partial<Svg> & { width?: number; height?: number; opacity?: number }) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 37 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={opacity}
      {...props}
    >
      <mask id="mask0_10093_3406" maskUnits="userSpaceOnUse" x="0" y="0" width="37" height="35">
        <path d="M36.231 0.00927734H0.230957V34.295H36.231V0.00927734Z" fill="white" />
      </mask>
      <g mask="url(#mask0_10093_3406)">
        <path opacity="0.4" fillRule="evenodd" clipRule="evenodd" d="M3.06945 3.84546C1.50179 3.84546 0.230957 5.12277 0.230957 6.69843V27.6519C0.230957 29.2276 1.50179 30.5049 3.06945 30.5049C4.63711 30.5049 5.90794 29.2276 5.90794 27.6519V6.69843C5.90794 5.12277 4.63711 3.84546 3.06945 3.84546ZM30.554 10.4885C30.554 8.91289 31.8249 7.6356 33.3924 7.6356C34.9601 7.6356 36.231 8.91289 36.231 10.4885V31.442C36.231 33.0177 34.9601 34.2951 33.3924 34.2951C31.8249 34.2951 30.554 33.0177 30.554 31.442V10.4885ZM15.3926 14.2958C15.3926 12.7202 16.6635 11.4429 18.2311 11.4429C19.7988 11.4429 21.0696 12.7202 21.0696 14.2958V25.7275C21.0696 27.3031 19.7988 28.5804 18.2311 28.5804C16.6635 28.5804 15.3926 27.3031 15.3926 25.7275V14.2958Z" fill="#00ADB9" />
        <path fillRule="evenodd" clipRule="evenodd" d="M25.8106 0.00927734C24.2429 0.00927734 22.9721 1.2866 22.9721 2.86224V27.6519C22.9721 29.2275 24.2429 30.5049 25.8106 30.5049C27.3783 30.5049 28.6491 29.2275 28.6491 27.6519V2.86224C28.6491 1.28659 27.3783 0.00927734 25.8106 0.00927734ZM10.6505 7.63556C9.08289 7.63556 7.81201 8.91283 7.81201 10.4885V31.442C7.81201 33.0177 9.08289 34.295 10.6505 34.295C12.2182 34.295 13.489 33.0177 13.489 31.442V10.4885C13.489 8.91283 12.2182 7.63556 10.6505 7.63556Z" fill="#00ADB9" />
      </g>
    </Svg>
  );
}

export function IconInfoTrac({
  width = 37,
  height = 36,
  opacity = 1,
  ...props
}: Partial<Svg> & { width?: number; height?: number; opacity?: number }) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 37 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={opacity}
      {...props}
    >
      <mask id="mask0_10093_99" maskUnits="userSpaceOnUse" x="0" y="0" width="37" height="35">
        <path d="M36.231 0.00927734H0.230957V34.295H36.231V0.00927734Z" fill="white" />
      </mask>
      <g mask="url(#mask0_10093_99)">
        <path opacity="0.4" fillRule="evenodd" clipRule="evenodd" d="M3.06945 3.84546C1.50179 3.84546 0.230957 5.12277 0.230957 6.69843V27.6519C0.230957 29.2276 1.50179 30.5049 3.06945 30.5049C4.63711 30.5049 5.90794 29.2276 5.90794 27.6519V6.69843C5.90794 5.12277 4.63711 3.84546 3.06945 3.84546ZM30.554 10.4885C30.554 8.91289 31.8249 7.6356 33.3924 7.6356C34.9601 7.6356 36.231 8.91289 36.231 10.4885V31.442C36.231 33.0177 34.9601 34.2951 33.3924 34.2951C31.8249 34.2951 30.554 33.0177 30.554 31.442V10.4885ZM15.3926 14.2958C15.3926 12.7202 16.6635 11.4429 18.2311 11.4429C19.7988 11.4429 21.0696 12.7202 21.0696 14.2958V25.7275C21.0696 27.3031 19.7988 28.5804 18.2311 28.5804C16.6635 28.5804 15.3926 27.3031 15.3926 25.7275V14.2958Z" fill="#1D9DE5" />
        <path fillRule="evenodd" clipRule="evenodd" d="M25.8106 0.00927734C24.2429 0.00927734 22.9721 1.2866 22.9721 2.86224V27.6519C22.9721 29.2275 24.2429 30.5049 25.8106 30.5049C27.3783 30.5049 28.6491 29.2275 28.6491 27.6519V2.86224C28.6491 1.28659 27.3783 0.00927734 25.8106 0.00927734ZM10.6505 7.63556C9.08289 7.63556 7.81201 8.91283 7.81201 10.4885V31.442C7.81201 33.0177 9.08289 34.295 10.6505 34.295C12.2182 34.295 13.489 33.0177 13.489 31.442V10.4885C13.489 8.91283 12.2182 7.63556 10.6505 7.63556Z" fill="#1D9DE5" />
      </g>
    </Svg>
  );
}

export function IconFileText(props: Partial<Svg> & { color?: string }) {
  // eslint-disable-next-line react/destructuring-assignment
  const fill = props.color || '#284F66';

  return (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M16 16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H8C7.44772 18 7 17.5523 7 17C7 16.4477 7.44772 16 8 16H16Z" fill={fill} />
      <path d="M16 12C16.5523 12 17 12.4477 17 13C17 13.5523 16.5523 14 16 14H8C7.44772 14 7 13.5523 7 13C7 12.4477 7.44772 12 8 12H16Z" fill={fill} />
      <path d="M10 8C10.5523 8 11 8.44772 11 9C11 9.55229 10.5523 10 10 10H8C7.44772 10 7 9.55229 7 9C7 8.44772 7.44772 8 8 8H10Z" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0986 1.00488C15.3276 1.02757 15.5429 1.12883 15.707 1.29297L20.707 6.29297C20.8946 6.4805 21 6.73478 21 7V20C21 20.7957 20.6837 21.5585 20.1211 22.1211C19.5585 22.6837 18.7957 23 18 23H6C5.20435 23 4.44151 22.6837 3.87891 22.1211C3.3163 21.5585 3 20.7957 3 20V4C3 3.20435 3.3163 2.44152 3.87891 1.87891C4.44152 1.3163 5.20435 1 6 1H15L15.0986 1.00488ZM6 3C5.73478 3 5.4805 3.10543 5.29297 3.29297C5.10543 3.4805 5 3.73478 5 4V20C5 20.2652 5.10543 20.5195 5.29297 20.707C5.48051 20.8946 5.73478 21 6 21H18C18.2652 21 18.5195 20.8946 18.707 20.707C18.8946 20.5195 19 20.2652 19 20V9H16C15.2044 9 14.4415 8.6837 13.8789 8.12109C13.3163 7.55849 13 6.79565 13 6V3H6ZM15 6C15 6.26522 15.1054 6.51949 15.293 6.70703C15.4805 6.89457 15.7348 7 16 7H18.5859L15 3.41406V6Z"
        fill={fill}
      />
    </Svg>
  );
}
export function IconListFilter(props: Partial<Svg>) {
  return (
    <Svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5 12.75C10.9142 12.75 11.25 13.0858 11.25 13.5C11.25 13.9142 10.9142 14.25 10.5 14.25H7.5C7.08579 14.25 6.75 13.9142 6.75 13.5C6.75 13.0858 7.08579 12.75 7.5 12.75H10.5Z" fill="white" />
      <path d="M12.75 8.25C13.1642 8.25 13.5 8.58579 13.5 9C13.5 9.41421 13.1642 9.75 12.75 9.75H5.25C4.83579 9.75 4.5 9.41421 4.5 9C4.5 8.58579 4.83579 8.25 5.25 8.25H12.75Z" fill="white" />
      <path d="M15.75 3.75C16.1642 3.75 16.5 4.08579 16.5 4.5C16.5 4.91421 16.1642 5.25 15.75 5.25H2.25C1.83579 5.25 1.5 4.91421 1.5 4.5C1.5 4.08579 1.83579 3.75 2.25 3.75H15.75Z" fill="white" />
    </Svg>
  );
}
export function IconBookmark(props: Partial<Svg>) {
  return (
    <Svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 5C18 4.73478 17.8946 4.48051 17.707 4.29297C17.5195 4.10543 17.2652 4 17 4H7C6.73478 4 6.4805 4.10543 6.29297 4.29297C6.10543 4.4805 6 4.73478 6 5V19.2764L11.5039 16.1318L11.6221 16.0742C11.9045 15.9589 12.2271 15.9781 12.4961 16.1318L18 19.2764V5ZM20 21C20 21.3565 19.8103 21.6863 19.502 21.8652C19.1937 22.0441 18.8134 22.045 18.5039 21.8682L12 18.1514L5.49609 21.8682C5.18663 22.045 4.80634 22.0441 4.49805 21.8652C4.18973 21.6863 4 21.3565 4 21V5C4 4.20435 4.3163 3.44152 4.87891 2.87891C5.44152 2.3163 6.20435 2 7 2H17C17.7956 2 18.5585 2.3163 19.1211 2.87891C19.6837 3.44151 20 4.20435 20 5V21Z" fill="currentColor" />
    </Svg>
  );
}
export function IconBookmarkCheck(props: Partial<Svg>) {
  return (
    <Svg width="16" height="16" viewBox="0 0 24 24" fill="#284F66" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M17 2C17.7956 2 18.5585 2.3163 19.1211 2.87891C19.6837 3.44151 20 4.20435 20 5V21C20 21.3565 19.8103 21.6863 19.502 21.8652C19.1937 22.0441 18.8134 22.045 18.5039 21.8682L12 18.1514L5.49609 21.8682C5.18663 22.045 4.80634 22.0441 4.49805 21.8652C4.18973 21.6863 4 21.3565 4 21V5C4 4.20435 4.3163 3.44152 4.87891 2.87891C5.44152 2.3163 6.20435 2 7 2H17ZM15.707 7.29297C15.341 6.9269 14.7619 6.90438 14.3691 7.22461L14.293 7.29297L11 10.5859L9.70703 9.29297L9.63086 9.22461C9.23813 8.90429 8.65909 8.92697 8.29297 9.29297C7.92685 9.65908 7.90426 10.2381 8.22461 10.6309L8.29297 10.707L10.293 12.707L10.3691 12.7754C10.7619 13.0956 11.341 13.0731 11.707 12.707L15.707 8.70703L15.7754 8.63086C16.0956 8.23813 16.073 7.65905 15.707 7.29297Z" fill="#284F66" />
    </Svg>

  );
}

export function IconFolder(props: Partial<Svg>) {
  return (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 18V5C1 4.20435 1.3163 3.44152 1.87891 2.87891C2.44152 2.3163 3.20435 2 4 2H7.92969L8.11621 2.00586C8.54833 2.03278 8.9701 2.1533 9.35254 2.35938C9.78972 2.59498 10.1624 2.93486 10.4355 3.34961H10.4346L11.2393 4.54004L11.2451 4.5498L11.3203 4.65039C11.4013 4.74505 11.4997 4.82391 11.6104 4.88281C11.7579 4.96136 11.9227 5.00158 12.0898 5H20L20.2969 5.01465C20.9835 5.08291 21.6289 5.38671 22.1211 5.87891C22.6837 6.44151 23 7.20435 23 8V18C23 18.7957 22.6837 19.5585 22.1211 20.1211C21.5585 20.6837 20.7957 21 20 21H4C3.20435 21 2.44151 20.6837 1.87891 20.1211C1.3163 19.5585 1 18.7957 1 18ZM3 18C3 18.2652 3.10543 18.5195 3.29297 18.707C3.48051 18.8946 3.73478 19 4 19H20C20.2652 19 20.5195 18.8946 20.707 18.707C20.8946 18.5195 21 18.2652 21 18V8C21 7.73478 20.8946 7.48051 20.707 7.29297C20.5429 7.12883 20.3276 7.02757 20.0986 7.00488L20 7H12.0996V6.99902C11.6014 7.00222 11.1098 6.88269 10.6699 6.64844C10.2304 6.41434 9.85641 6.07399 9.58105 5.65918L8.77148 4.45996L8.76465 4.4502C8.67366 4.31204 8.54989 4.19865 8.4043 4.12012C8.29512 4.06128 8.17606 4.02311 8.05371 4.00781L7.92969 4H4C3.73478 4 3.4805 4.10543 3.29297 4.29297C3.10543 4.4805 3 4.73478 3 5V18Z" fill="currentColor" />
    </Svg>
  );
}

export function IconFolderOpen(props: Partial<Svg>) {
  return (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.01465 4.70294C1.08293 4.01634 1.38673 3.3709 1.87891 2.87872C2.44151 2.31614 3.20437 1.99982 4 1.99982H7.90039C8.39863 1.99662 8.89021 2.11811 9.33008 2.35236C9.76929 2.58635 10.1427 2.92617 10.418 3.34064L11.2285 4.54083L11.2354 4.54962L11.3096 4.64923C11.3896 4.74303 11.4865 4.82183 11.5957 4.88068C11.7414 4.95921 11.9048 4.99979 12.0703 4.99982H18C18.7956 4.99982 19.5585 5.31614 20.1211 5.87872C20.6837 6.44131 21 7.2042 21 7.99982V9.16974C21.1091 9.20815 21.2159 9.25349 21.3203 9.3045C21.7321 9.50573 22.0931 9.79888 22.374 10.1609C22.6548 10.5229 22.8488 10.9447 22.9414 11.3934C23.0341 11.8421 23.0228 12.3061 22.9082 12.7498L21.3682 18.7488C21.2011 19.3961 20.8228 19.9701 20.293 20.3777C19.7649 20.784 19.1163 21.0018 18.4502 20.9988L4 20.9998C3.20435 20.9998 2.44152 20.6835 1.87891 20.1209C1.31633 19.5583 1 18.7954 1 17.9998V4.99982L1.01465 4.70294ZM6.88867 14.4598C6.63497 14.95 6.03142 15.1418 5.54102 14.8885C5.05062 14.6348 4.85795 14.0313 5.11133 13.5408L6.88867 14.4598ZM3 17.9998C3 18.265 3.10546 18.5193 3.29297 18.7068C3.48051 18.8944 3.73478 18.9998 4 18.9998H18.457L18.6221 18.9871C18.7854 18.9609 18.9407 18.8947 19.0732 18.7928C19.2056 18.691 19.3097 18.558 19.377 18.407L19.4316 18.2498L20.9717 12.2518V12.2498L20.9941 12.1375C21.0098 12.0247 21.0056 11.9097 20.9824 11.7977C20.9515 11.6481 20.8876 11.5072 20.7939 11.3865C20.7003 11.2658 20.5796 11.1685 20.4424 11.1014C20.3052 11.0344 20.1546 10.9996 20.002 10.9998H9.2627L9.12793 11.0115C8.99472 11.0329 8.86678 11.0815 8.75195 11.1541C8.59877 11.251 8.47509 11.3878 8.39355 11.5496L8.38867 11.5594L6.88867 14.4598L5.11133 13.5408L6.61133 10.6404C6.85599 10.1588 7.22688 9.75241 7.68359 9.46368C8.14327 9.17314 8.67314 9.01242 9.2168 8.99982H19V7.99982C19 7.73464 18.8945 7.4803 18.707 7.29279C18.5429 7.12867 18.3276 7.02739 18.0986 7.0047L18 6.99982H12.0703C11.5737 6.99974 11.0846 6.87602 10.6475 6.64044C10.2103 6.40482 9.83762 6.06499 9.56445 5.65021L8.76074 4.45978L8.75488 4.45001C8.6629 4.31033 8.53727 4.19562 8.38965 4.117C8.24215 4.03847 8.07725 3.99824 7.91016 3.99982H4C3.73481 3.99982 3.4805 4.10528 3.29297 4.29279C3.10546 4.4803 3.00003 4.73464 3 4.99982V17.9998Z" fill="currentColor" />
    </Svg>
  );
}

export function IconPaperclip(props: Partial<Svg>) {
  return (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 1.00098C17.3256 1.0011 18.5967 1.52773 19.5342 2.46484L19.7061 2.64453C20.5362 3.56163 20.999 4.75715 20.999 6C20.999 7.32246 20.474 8.59041 19.541 9.52734L19.542 9.52832L11.1279 18.1143L11.1201 18.1211C10.5577 18.6833 9.79525 18.9999 9 19C8.20457 19 7.44148 18.6834 6.87891 18.1211C6.31665 17.5586 6.00003 16.7954 6 16C6.00003 15.2078 6.31307 14.4476 6.87109 13.8857L15.2852 5.2998L15.3604 5.23047C15.7499 4.90619 16.3294 4.92375 16.6992 5.28613C17.0936 5.67269 17.1004 6.30576 16.7139 6.7002L8.2998 15.2861L8.29297 15.293C8.10557 15.4805 8.00003 15.7349 8 16C8.00003 16.2651 8.10553 16.5195 8.29297 16.707L8.36621 16.7734C8.54409 16.919 8.76812 17 9 17C9.26482 16.9999 9.51867 16.8942 9.70605 16.707L18.1133 8.12793L18.1201 8.12109L18.3193 7.90137C18.7567 7.36757 18.999 6.69613 18.999 6C18.999 5.3041 18.7564 4.63333 18.3193 4.09961L18.1201 3.87891C17.5577 3.31687 16.7951 3.0011 16 3.00098C15.2047 3.00098 14.4415 3.31674 13.8789 3.87891L5.4707 12.457L5.46387 12.4639C4.52616 13.4016 3.99906 14.6739 3.99902 16C3.99906 17.3262 4.52612 18.5984 5.46387 19.5361C6.40162 20.4738 7.67389 21.001 9 21.001L9.24707 20.9941C10.406 20.9367 11.5093 20.4779 12.3672 19.6963L12.5352 19.5361L20.2852 11.6016L20.3604 11.5312C20.7492 11.2067 21.3289 11.2226 21.6992 11.584C22.0942 11.9697 22.1013 12.6029 21.7158 12.998L13.9502 20.9502L13.9219 20.9766C12.6941 22.1909 11.0642 22.907 9.34668 22.9922L9 23.001C7.14346 23.001 5.36263 22.2629 4.0498 20.9502C2.73698 19.6374 1.99906 17.8566 1.99902 16C1.99906 14.1467 2.7336 12.3688 4.04199 11.0566L12.457 2.47168L12.4648 2.46484L12.6445 2.29395C13.5616 1.46386 14.7571 1.00098 16 1.00098Z" fill="currentColor" />
    </Svg>

  );
}

export function IconSmile(props: Partial<Svg>) {
  return (
    <Svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10298_4067)">
        <path d="M11.4001 10.0503C11.6486 9.71896 12.1183 9.65172 12.4497 9.90015C12.781 10.1486 12.8483 10.6183 12.5999 10.9497L12 10.5C12.588 10.941 12.5998 10.9493 12.5999 10.9497L12.5984 10.9519C12.5978 10.9527 12.5969 10.9538 12.5962 10.9548C12.5947 10.9568 12.5931 10.9595 12.5911 10.9622C12.5869 10.9676 12.5814 10.9745 12.575 10.9827C12.562 10.999 12.5442 11.0202 12.5222 11.0464C12.4782 11.0988 12.416 11.1704 12.3362 11.2537C12.1771 11.4196 11.9445 11.6379 11.644 11.8564C11.0456 12.2917 10.1441 12.75 9 12.75C7.85591 12.75 6.95441 12.2917 6.35596 11.8564C6.05547 11.6379 5.82287 11.4196 5.66382 11.2537C5.58398 11.1704 5.52177 11.0988 5.47778 11.0464C5.45585 11.0202 5.43797 10.999 5.42505 10.9827C5.41861 10.9745 5.41311 10.9676 5.40894 10.9622C5.40686 10.9595 5.40532 10.9568 5.40381 10.9548C5.40305 10.9538 5.40222 10.9527 5.40161 10.9519L5.40015 10.9504C5.4002 10.95 5.41205 10.941 6 10.5L5.40015 10.9504C5.15172 10.6191 5.21896 10.1486 5.55029 9.90015C5.88158 9.65178 6.35058 9.71916 6.59912 10.0503L6.59985 10.0496C6.60032 10.05 6.60085 10.0504 6.60132 10.051C6.60578 10.0567 6.61381 10.0677 6.62622 10.0825C6.65104 10.1121 6.69156 10.1579 6.74634 10.2151C6.8568 10.3303 7.02288 10.4872 7.23779 10.6436C7.67059 10.9583 8.26915 11.25 9 11.25C9.73085 11.25 10.3294 10.9583 10.7622 10.6436C10.9771 10.4872 11.1432 10.3303 11.2537 10.2151C11.3084 10.1579 11.349 10.1121 11.3738 10.0825C11.3862 10.0677 11.3942 10.0567 11.3987 10.051L11.4009 10.0481L11.4001 10.0503Z" fill="#00ADB9" />
        <path d="M6.83423 6.00366C7.21241 6.04208 7.50732 6.36168 7.50732 6.75C7.50732 7.13832 7.21241 7.45792 6.83423 7.49634L6.75732 7.5H6.75C6.33579 7.5 6 7.16421 6 6.75C6 6.33579 6.33579 6 6.75 6H6.75732L6.83423 6.00366Z" fill="#00ADB9" />
        <path d="M11.3342 6.00366C11.7124 6.04208 12.0073 6.36168 12.0073 6.75C12.0073 7.13832 11.7124 7.45792 11.3342 7.49634L11.2573 7.5H11.25C10.8358 7.5 10.5 7.16421 10.5 6.75C10.5 6.33579 10.8358 6 11.25 6H11.2573L11.3342 6.00366Z" fill="#00ADB9" />
        <path fillRule="evenodd" clipRule="evenodd" d="M9 0.75C13.5563 0.75 17.25 4.44365 17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9C0.75 4.44365 4.44365 0.75 9 0.75ZM9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25Z" fill="#00ADB9" />
      </g>
      <defs>
        <clipPath id="clip0_10298_4067">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  );
}

export function IconFrown(props: Partial<Svg>) {
  return (
    <Svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.5 9.75C10.644 9.75 11.5456 10.2084 12.144 10.6436C12.4445 10.8621 12.6771 11.0804 12.8362 11.2463C12.916 11.3296 12.9782 11.4012 13.0222 11.4536C13.0441 11.4797 13.062 11.501 13.075 11.5173C13.0814 11.5254 13.0869 11.5324 13.0911 11.5378C13.0931 11.5405 13.0947 11.5432 13.0962 11.5452C13.0969 11.5461 13.0978 11.5473 13.0984 11.5481L13.0999 11.5496C13.0986 11.5507 13.0772 11.5668 12.741 11.8191L13.0999 11.5496C13.3483 11.8809 13.281 12.3514 12.9497 12.5999C12.6183 12.8482 12.1486 12.781 11.9001 12.4497L11.9009 12.4512L11.8987 12.449C11.8942 12.4433 11.8861 12.4322 11.8738 12.4175C11.849 12.3879 11.8084 12.342 11.7537 12.2849C11.6432 12.1697 11.4771 12.0127 11.2622 11.8564C10.8294 11.5417 10.2308 11.25 9.5 11.25C8.76922 11.25 8.17056 11.5417 7.73779 11.8564C7.52293 12.0127 7.35678 12.1697 7.24634 12.2849C7.1916 12.3421 7.15103 12.3879 7.12622 12.4175C7.11385 12.4322 7.10577 12.4433 7.10132 12.449C7.10083 12.4496 7.10032 12.45 7.09985 12.4504L7.09912 12.4497C6.85056 12.7808 6.38155 12.8482 6.05029 12.5999C5.71907 12.3514 5.65181 11.8816 5.90015 11.5503L6.25903 11.8191C5.90878 11.5563 5.90019 11.5506 5.90015 11.5503L5.90161 11.5481C5.90221 11.5473 5.90307 11.5461 5.90381 11.5452C5.9053 11.5432 5.90689 11.5405 5.90894 11.5378C5.91309 11.5324 5.91863 11.5254 5.92505 11.5173C5.93795 11.501 5.95587 11.4797 5.97778 11.4536C6.02175 11.4012 6.08402 11.3296 6.16382 11.2463C6.32285 11.0804 6.55552 10.8621 6.85596 10.6436C7.45438 10.2084 8.35598 9.75004 9.5 9.75Z" fill="#E0425B" />
      <path d="M7.33423 6.00366C7.71241 6.04208 8.00732 6.36168 8.00732 6.75C8.00732 7.13832 7.71241 7.45792 7.33423 7.49634L7.25732 7.5H7.25C6.83579 7.5 6.5 7.16421 6.5 6.75C6.5 6.33579 6.83579 6 7.25 6H7.25732L7.33423 6.00366Z" fill="#E0425B" />
      <path d="M11.8342 6.00366C12.2124 6.04208 12.5073 6.36168 12.5073 6.75C12.5073 7.13832 12.2124 7.45792 11.8342 7.49634L11.7573 7.5H11.75C11.3358 7.5 11 7.16421 11 6.75C11 6.33579 11.3358 6 11.75 6H11.7573L11.8342 6.00366Z" fill="#E0425B" />
      <path fillRule="evenodd" clipRule="evenodd" d="M9.5 0.75C14.0563 0.75 17.75 4.44365 17.75 9C17.75 13.5563 14.0563 17.25 9.5 17.25C4.94365 17.25 1.25 13.5563 1.25 9C1.25 4.44365 4.94365 0.75 9.5 0.75ZM9.5 2.25C5.77208 2.25 2.75 5.27208 2.75 9C2.75 12.7279 5.77208 15.75 9.5 15.75C13.2279 15.75 16.25 12.7279 16.25 9C16.25 5.27208 13.2279 2.25 9.5 2.25Z" fill="#E0425B" />
    </Svg>
  );
}

export default Svg;
